import { CSSProperties, useCallback, ReactNode } from "react"
import TextField, { TextFieldProps } from "@mui/material/TextField"
import InputAdornment from '@mui/material/InputAdornment'

type NumericInputProps = {
  state: string
  setState: (text: string) => void
  label?: string
  style?: CSSProperties
  required?: boolean
  fullWidth?: boolean
  prefix?: ReactNode
  suffix?: ReactNode
} & TextFieldProps
export const NumericInput = ({
  state,
  setState,
  label,
  style,
  required,
  fullWidth,
  prefix,
  suffix,
  ...others
}: NumericInputProps) => {
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const result = Math.abs(Number(e.target.value)).toString()
      if (result === "NaN") {
        setState("")
      } else {
        setState(result)
      }
    },
    [setState]
  )
  return (
    <TextField
      fullWidth={fullWidth}
      required={required}
      value={state}
      onChange={onChange}
      label={label}
      style={style}
      size='small'
      slotProps={{
        input: {
          inputMode: "numeric",
          startAdornment: prefix && (
            <InputAdornment position="start">{prefix}</InputAdornment>
          ),
          endAdornment: suffix && (
            <InputAdornment position="end">{suffix}</InputAdornment>
          )
        }
      }}
      {...others}
    />
  );
}